export default __webpack_public_path__ + "src/assets/credits-0x.65da85ed05ebebf685078cbfa71b2f7f.svg";